import Helper from "../common/Helper";
import {ajaxRequest} from "../common/Ajax";

function popupCreateUpdateFleetVehicle(rowData = {}, confirmBtnText) {

    let popupTitle = 'Adaugă';
    let initValues = {}

    if (rowData?.name) {
        popupTitle = 'Editează'
        initValues = {
            name: rowData?.name,
            plate_number: rowData?.plate_number,
            vin: rowData?.vin,
            year: rowData?.year,
            current_km: rowData?.current_km,
            is_active: rowData?.is_active,
        }
    }


    let fields = {
        'name': {
            label: {text: 'Marca & Model'},
            input: {
                type: 'text',
                value: initValues?.name ?? '',
                placeholder: 'Volkswagen Caddy'
            },
            field: {class: 'col-span-2'}
        },
        'plate_number': {
            label: {text: 'Numere de înmatriculare'},
            input: {
                type: 'text',
                value: initValues?.plate_number ?? '',
                placeholder: 'VXI 304'
            }
        },
        'vin': {
            label: {text: 'VIN'},
            input: {type: 'text', value: initValues?.vin ?? '', placeholder: 'WV1ZZZ2KZHX157339'}
        },
        'year': {
            label: {text: 'An fabricație'},
            input: {type: 'number', value: initValues?.year, placeholder: '2026'}
        },
        'current_km': {
            label: {text: 'Kilometraj curent'},
            input: {type: 'number', value: initValues?.current_km}
        },
        'is_active': {
            label: {
                text: ESR.lang.visibility
            },
            input: {
                type: 'select',
                value: initValues?.visibility ?? 1,
                options: [
                    {value: 1, label: ESR.lang.visible},
                    {value: 0, label: ESR.lang.hidden}
                ]
            }
        }
    };


    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>`);

    ESR.View.appendFields(popupContent, fields);


    //append from fields

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            let data = ESR.View.getFieldsValues(fields);
            data.id = rowData?.id ?? 0;

            if (!data.name.length) {
                Swal.showValidationMessage('Completează denumirea');
                popupContent.find('#sw-input-name').focus();
                return;
            }

            if (!data.vin.length) {
                Swal.showValidationMessage('Cîmpul VIN este obloigatoriu');
                popupContent.find('#sw-input-current_km').focus();
                return;
            }

            if (!data.current_km.length) {
                Swal.showValidationMessage('Completează chilometrajul curent');
                popupContent.find('#sw-input-current_km').focus();
                return;
            }

            return await ajaxRequest({action: "esr_update_fleet_vehicle", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export default function tableVehicles(HelperTable) {

    const selectorTable = '#table-vehicles';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const canCreate = Helper.userCan('create_fleet_vehicle')
    const canEdit = Helper.userCan('edit_fleet_vehicle')
    const canDelete = Helper.userCan('delete_fleet_vehicle')

    const columns = [
        {label: 'ID', data: 'id', orderable: true},
        {data: 'name', label: 'Denumire', orderable: false},
        // {data: null, defaultContent: '',  label: 'Acțiuni', orderable: false, searchable: false},
        {data: 'vin', label: 'VIN', orderable: false},
        {data: 'year', label: 'An', orderable: true},
        {data: 'current_km', label: 'Km', orderable: true},
        {data: 'service_status', label: 'Deservire', orderable: false},
        {data: 'is_active', label: 'Statut', orderable: false},
        {data: 'updated_at', label: 'Actualizat La', visible: true},
        {data: 'created_at', label: 'Creat La', visible: false},
    ];

    const columnDefs = [
        {
            targets: 0, // ID
            width: '60px',
            className: 'text-center'
        },
        {
            targets: 1, // Name
            width: '300px',
            render: (data, type, row) => {

                if (type === 'display') {
                    const url = ESR.Helper.getAutoUrl(row.vin.toLowerCase())
                    let html = `<a href="${url}">${row.name} - ${row.plate_number}</a>`;
                    return html;
                } else if (type === 'filter') {
                    return row.name + ' ' + row.plate_number;
                }

                return data;
            }
        },
        // {
        //     targets: 2, // VIN
        //     width: '160px',
        //     render: (data, type, row) => {
        //
        //         if (type === 'display') {
        //             const url = ESR.Helper.getAutoUrl(row.vin.toLowerCase())
        //             let html = `<a href="${url+'/service/'}" class="btn-action">Deservire</a>`;
        //             return html;
        //         }
        //
        //         return data;
        //     }
        // },
        {
            targets: 2, // VIN
            width: '160px',
        },
        {
            targets: 3, // AN
            width: '50px',
        },
        {
            targets: 4, // KM
            width: '100px',
        },
        {
            targets: 5, // Active
            width: '60px',
            render: function (data, type, row) {
                if (type === 'display') {
                    if (data === 'ok') return 'Ok';
                    if (data === 'expiring') return 'Expiră';
                    if (data === 'expired') return 'Expirat';
                }

                return data;
            }
        },
        {
            targets: 6, // Active
            width: '80px',
            render: function (data, type, row) {
                if (type === 'display') {
                    return data === '1' ? 'Activ' : 'Inactiv'
                }
                return data;
            }
        },
        {
            targets: 7, // Created At
            width: '150px',
        },
        {
            targets: 8, // Updated At
            width: '150px',
        }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    let toolbarButtons = [HelperTable.btnColvis(), HelperTable.btnDownloads()];

    if (canCreate) {
        function callbackBtnAdd(e) {
            e.preventDefault();
            popupCreateUpdateFleetVehicle({}, ESR.lang.update);
        }

        toolbarButtons.push(HelperTable.btnAdd(e => callbackBtnAdd(e)))
    }

    if (canEdit) {
        function callbackBtnEdit(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            popupCreateUpdateFleetVehicle(elRow.data(), ESR.lang.update);
        }

        toolbarButtons.push(HelperTable.btnEdit(e => callbackBtnEdit(e)))
    }

    if (canDelete) {
        function callbackBtnRemove(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            const rowData = elRow.data();

            ESR.Popup.delete({
                title: rowData.title,
                html: `<p>Toată <b>datele</b> și <b>istoria</b> vor fi șterse definitiv, doriți să ștergeți ?</p`,
                action: 'esr_remove_fleet_vehicle',
                id: rowData.id
            })
        }

        toolbarButtons.push(HelperTable.btnRemove(e => callbackBtnRemove(e)))
    }

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        columnDefs: columnDefs,
        stateSave: false,
        displayLength: 20,
        order: [
            [0, 'dsc']
        ],
        processing: false,
        serverSide: false,
        info: false,
        layout: {

            topStart: {
                buttons: toolbarButtons,
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
        initComplete: function () {
            const api = this.api();
            const state = api.state.loaded()


            const colStatus = api.column(6);
            const colStatusStateValue = state?.columns[6].search.search ?? '';

            const elSelectStatus = ESR.View.select({
                value: colStatusStateValue,
                class: 'select-status select-sm',
                name: 'status',
                placeholder: ESR.lang.status,
                options: [
                    {value: 1, label: 'Activ'},
                    {value: 0, label: 'Inactiv'}
                ]
            }).on('change', function () {
                colStatus.search($(this).val(), {exact: false}).draw();
            });

            $('.dt-layout-end').prepend(elSelectStatus)


            const colService = api.column(5);
            const colServiceStateValue = state?.columns[5].search.search ?? '';

            const elSelectService = ESR.View.select({
                value: colServiceStateValue,
                class: 'select-service select-sm',
                name: 'service',
                placeholder: 'Deservire',
                options: [
                    {value: 'ok', label: 'Ok'},
                    {value: 'expiring', label: 'Expiră'},
                    {value: 'expired', label: 'Expirat'}
                ]
            }).on('change', function () {
                colService.search($(this).val(), {exact: false}).draw();
            });

            $('.dt-layout-end').prepend(elSelectService)
        }
    });


    if (canCreate) {
        const btnRowEdit = table.buttons().container().find('.btn-row-edit')
        const btnRowRemove = table.buttons().container().find('.btn-row-remove')
        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove)
        });
    }

}